import PratusTextArea from 'components/DesignSystems/New/PratusTextArea';
import { useIncidentInfo, useUpdateIcsInfo } from '../hooks/incidentInfoHooks';
import { ConditionalCollapsibleCard } from '../ConditionalCollapsibleCard';

const InitialResponseOverview: React.FC = () => {
  const { data: incidentInfo } = useIncidentInfo();

  const mutation = useUpdateIcsInfo();

  return (
    <ConditionalCollapsibleCard
      sectionKey={'initial-response-overview'}
      className="planning-widget"
      contentClassName="content mt-2"
      headerLeft={<h3 className="mb-0 mt-0">Current Situation</h3>}
    >
      <PratusTextArea
        rows={15}
        placeholder="Enter current situation details..."
        value={incidentInfo?.situationSummary || ''}
        onSave={(value) => {
          mutation.mutate({ ...incidentInfo, situationSummary: value });
        }}
      />
    </ConditionalCollapsibleCard>
  );
};

export default InitialResponseOverview;
